export default __webpack_public_path__ + "static/logo-white-6eca13bf04a1d6c80e6c65b36bce7138.png";